import type { LayerRect } from './types';

/** Shrink a fractional rect so its DISPLAYED aspect ratio matches the media's
 *  natural aspect, centered inside the original box ("contain"). Rect
 *  fractions are relative to the composition, so the displayed ratio of a
 *  rect is (w/h)·compAspect; we solve for w/h = mediaAspect/compAspect.
 *  Degenerate inputs return the rect unchanged. */
export function fitRectToAspect(
  { rect, mediaAspect, compAspect }:
  { rect: LayerRect; mediaAspect: number; compAspect: number },
): LayerRect {
  if (!Number.isFinite(mediaAspect) || mediaAspect <= 0) return rect;
  if (!Number.isFinite(compAspect) || compAspect <= 0) return rect;
  const targetWH = mediaAspect / compAspect;
  const currentWH = rect.w / rect.h;
  if (Math.abs(currentWH - targetWH) < 1e-9) return rect;
  let w = rect.w;
  let h = rect.h;
  if (currentWH > targetWH) {
    w = rect.h * targetWH;
  } else {
    h = rect.w / targetWH;
  }
  return {
    x: rect.x + (rect.w - w) / 2,
    y: rect.y + (rect.h - h) / 2,
    w,
    h,
  };
}
